import React, { FC, Fragment, InputHTMLAttributes } from 'react';
import Check from '../Icons/fill/Check';
import { InputStyled, CheckboxStyled, RadioStyled } from './InputStyled';
import ErrorMessage from '../ErrorMessage';
import { trackEvent } from '~/helpers/tracking';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  masked?: boolean;
  registerProps?: Record<string, unknown>;
  error?: string;
}

const Input: FC<Props> = ({ registerProps, error, ...props }) => {
  const { type } = props;
  const handleFieldInputted = (event) => {
    trackEvent({
      action: 'fieldInputted',
      event,
    });
  };

  if (type === 'checkbox') {
    return (
      <CheckboxStyled>
        <input {...props} {...registerProps} />
        <span>
          <Check />
        </span>
      </CheckboxStyled>
    );
  }

  if (type === 'radio') {
    return (
      <RadioStyled>
        <input {...props} {...registerProps} />
        <span />
      </RadioStyled>
    );
  }

  return (
    <Fragment>
      <InputStyled onBlur={handleFieldInputted} {...props} {...registerProps} error={error} data-private="lipsum" />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </Fragment>
  );
};

Input.displayName = 'Input';

Input.defaultProps = {
  registerProps: {},
};

export default Input;
